/**
 * DataLayer Manager - Moon Moon Agency
 * Centralise les events tracking GTM/GA4 (sign_up, login, contact, newsletter, filter, sort)
 */

const MmDataLayer = {

	async hashSHA256(value) {
		if (!value) return '';
		const encoded = new TextEncoder().encode(String(value).toLowerCase().trim());
		const buffer = await crypto.subtle.digest('SHA-256', encoded);
		return Array.from(new Uint8Array(buffer)).map(b => b.toString(16).padStart(2, '0')).join('');
	},

	push(payload) {
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push(payload);
		window.log?.('info', '📊 [DATALAYER]', payload.event, payload);
	},

	async pushSignUp(userId, email, phone) {
		const emailHashed = await this.hashSHA256(email);
		const phoneHashed = phone ? await this.hashSHA256(phone) : '';
		this.push({
			event: 'sign_up',
			user_id: userId,
			user_email_hashed: emailHashed,
			user_email: email || '',
			user_phone_hashed: phoneHashed,
		});
	},

	async pushLogin(userId, email) {
		const emailHashed = await this.hashSHA256(email);
		this.push({
			event: 'login',
			user_id: userId,
			user_email_hashed: emailHashed,
			user_email: email || '',
		});
	},

	async pushContactFormSubmit(email) {
		const emailHashed = await this.hashSHA256(email);
		this.push({
			event: 'contact_form_submit',
			user_email_hashed: emailHashed,
			user_email: email || '',
		});
	},

	async pushNewsletterFormSubmit(email, position) {
		const emailHashed = await this.hashSHA256(email);
		this.push({
			event: 'newsletter_form_submit',
			user_email_hashed: emailHashed,
			user_email: email || '',
			position: position || '',
		});
	},

	/*
	 * Parse Shopify filter URL params → champs dataLayer attendus par Samantha.
	 * Les clés Shopify (filter.p.m.custom.*) sont mappées via substring matching
	 * pour être robustes aux variations de nommage du store.
	 */
	_parseFilterParams(urlFilterString) {
		const params = new URLSearchParams(urlFilterString);
		const result = { size: '', colour: '', number_of_ply: '', price_range: '', material: '', cut: '' };
		let priceMin = '', priceMax = '';

		params.forEach((value, key) => {
			const lk = key.toLowerCase();
			if (lk.includes('taille') || lk.includes('size')) {
				result.size = result.size ? result.size + ',' + value : value;
			} else if (lk.includes('couleur') || lk.includes('color') || lk.includes('colour') || lk.includes('colors_family')) {
				result.colour = result.colour ? result.colour + ',' + value : value;
			} else if (lk.includes('fils') || lk.includes('ply') || lk.includes('nb_fil')) {
				result.number_of_ply = result.number_of_ply ? result.number_of_ply + ',' + value : value;
			} else if (lk.includes('matiere') || lk.includes('material') || lk.includes('matière')) {
				result.material = result.material ? result.material + ',' + value : value;
			} else if (lk.includes('coupe') || lk.includes('cut')) {
				result.cut = result.cut ? result.cut + ',' + value : value;
			} else if (lk.includes('price') && lk.includes('gte')) {
				priceMin = value;
			} else if (lk.includes('price') && lk.includes('lte')) {
				priceMax = value;
			}
		});

		if (priceMin || priceMax) {
			result.price_range = (priceMin || '0') + '-' + (priceMax || '');
		}

		return result;
	},

	_initCollectionListeners() {
		/*
		 * filter_apply — se déclenche sur collection:filter-success
		 * Couvre les filtres cases à cocher ET le color strip (ColorGroupFilters).
		 */
		document.addEventListener('collection:filter-success', (e) => {
			const filters = e.detail?.data?.filters || '';
			if (!filters) return;
			const parsed = this._parseFilterParams(filters);
			this.push({ event: 'filter_apply', ...parsed });
		});

		/* sort_by_apply — sort-change est émis avant la navigation de page */
		document.addEventListener('collection:sort-change', (e) => {
			const value = e.detail?.data?.value || '';
			this.push({ event: 'sort_by_apply', sort_by: value });
		});
	},

	init() {
		this._initCollectionListeners();
		window.log?.('info', '📊 [DATALAYER]', 'Initialized');
	},
};

window.MmDataLayer = MmDataLayer;

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', () => MmDataLayer.init());
} else {
	MmDataLayer.init();
}
